module.exports = __webpack_public_path__ + "media/images/blazestake-18a15367.png";